import React, { useState } from 'react';
import ListningarTimeline from './ListningarTimeline';
import ListningarEntryEditor from './ListningarEntryEditor';
import { IListningarEntry } from './types';

interface ListningarModuleProps {
  onClose: () => void;
  currentUser: any;
}

type View =
  | { type: 'timeline' }
  | { type: 'editor'; entry?: IListningarEntry };

const ListningarModule: React.FC<ListningarModuleProps> = ({ onClose, currentUser }) => {
  const [view, setView] = useState<View>({ type: 'timeline' });
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateNew = () => {
    setView({ type: 'editor' });
  };

  const handleEdit = (entry: IListningarEntry) => {
    setView({ type: 'editor', entry });
  };

  const handleEditorClose = () => {
    setView({ type: 'timeline' });
  };

  const handleSaved = () => {
    setRefreshKey(prev => prev + 1);
    setView({ type: 'timeline' });
  };

  if (view.type === 'editor') {
    return (
      <ListningarEntryEditor
        entry={view.entry}
        onClose={handleEditorClose}
        onSaved={handleSaved}
        currentUser={currentUser}
      />
    );
  }

  return (
    <ListningarTimeline
      onClose={onClose}
      onCreateNew={handleCreateNew}
      onEdit={handleEdit}
      currentUser={currentUser}
      refreshKey={refreshKey}
    />
  );
};

export default ListningarModule;
